import { render, staticRenderFns } from "./InlineActionsButton.vue?vue&type=template&id=728f356f&scoped=true&"
import script from "./InlineActionsButton.vue?vue&type=script&lang=js&"
export * from "./InlineActionsButton.vue?vue&type=script&lang=js&"
import style0 from "./InlineActionsButton.vue?vue&type=style&index=0&id=728f356f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f356f",
  null
  
)

export default component.exports